/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


document.addEventListener('variant:changed', function(event) {
  const availability = document.querySelector('.product-form__availability')
  const addToCart = document.querySelector('#AddToCart')

  if (!availability || !addToCart) return

  const isHidden = availability.hasAttribute('hidden')
  const isDisabled = addToCart.hasAttribute('disabled')

  if (isDisabled && isHidden) {
    availability.style.display = 'flex'
    availability.removeAttribute('hidden')
  }

  if (!isDisabled && !isHidden) {
    availability.style.display = 'none'
    availability.setAttribute('hidden', '')
  }
});

class AdvancedCard extends HTMLElement {
      constructor() {
        super();
        this.body = document.body;
        this.html = document.documentElement;
        this.ancestorContainer = this.closest(".shopify-section--advanced-cards");
        this.mobileOverlay = this.querySelector(".overlay-body");
        this.closeBtn = this.querySelector('[close-overlay-btn]');
        this.BODY_CLASS = 'lock-all';
        this.IS_TOUCH_SCREEN = this.isTouchDevice();
        this.attachEventListeners();
      }
  
      attachEventListeners() {
        window.addEventListener('resize', () => { this.handleResize() });
        this.handleResize(); // Initial call to handle the current window size
        
        if (this.IS_TOUCH_SCREEN) {
          this.addEventListener('click', () => { this.showOverlay() });
          this.closeBtn.addEventListener('click', (e) => { this.hideOverlay(); e.stopPropagation(); })
          window.addEventListener('click', (e) => {
            if (e.target.contains(this.mobileOverlay) && e.target !== this.mobileOverlay) { this.hideOverlay() }
          })
        } else {
          this.addEventListener('mouseover', () => { this.showOverlay() })
          this.addEventListener('mouseleave', () => { this.hideOverlay() })
        }
      }
  
      handleResize() {
        this.IS_TOUCH_SCREEN = this.isTouchDevice();
        if (this.IS_TOUCH_SCREEN && window.innerWidth < 900) {
          // Remove existing event listeners
          this.removeEventListener('mouseover', () => { this.showOverlay() });
          this.removeEventListener('mouseleave', () => { this.hideOverlay() });
          
          // Add click event listeners
          this.addEventListener('click', () => { this.showOverlay() });
          this.closeBtn.addEventListener('click', (e) => { this.hideOverlay(); e.stopPropagation(); })
          window.addEventListener('click', (e) => {
            if (e.target.contains(this.mobileOverlay) && e.target !== this.mobileOverlay) { this.hideOverlay() }
          })
        } else {
          // Remove click event listeners
          this.removeEventListener('click', () => { this.showOverlay() });
          this.closeBtn.removeEventListener('click', (e) => { this.hideOverlay(); e.stopPropagation(); })
          window.removeEventListener('click', (e) => {
            if (e.target.contains(this.mobileOverlay) && e.target !== this.mobileOverlay) { this.hideOverlay() }
          })
          
          // Add existing event listeners
          this.addEventListener('mouseover', () => { this.showOverlay() })
          this.addEventListener('mouseleave', () => { this.hideOverlay() })
        }
      }
  
      isTouchDevice() {
        return this.body.clientWidth < 950 ? true : false;
      }
  
      showOverlay() {
        this.setAttribute("opened", "");
        if (this.IS_TOUCH_SCREEN) this.html.classList.add(this.BODY_CLASS);
        this.ancestorContainer.classList.add('active');
      }
  
      hideOverlay() {
        setTimeout(() => { this.ancestorContainer.classList.remove('active'); }, 200);
        this.removeAttribute("opened");
        this.html.classList.remove(this.BODY_CLASS);
      }
    }
customElements.define("advanced-card", AdvancedCard);


class RevealOnScroll {
    constructor(selector, options = {}) {
      this.selector = selector;
      this.options = Object.assign({
        threshold: 0.5,
        rootMargin: '0px',
        visibleClass: 'is-visible',
        animateClass: 'animate'
      }, options);
  
      
      this.sections = document.querySelectorAll('[data-reveal-on-scroll]');
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
        rootMargin: this.options.rootMargin,
        threshold: this.options.threshold
      });
  
      this.sections.forEach(($section) => {
        this.observer.observe($section);
      });
    }
  
    handleIntersection(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add(this.options.visibleClass);
          entry.target.classList.add(this.options.animateClass);
          observer.unobserve(entry.target);
        }
      });
    }
  
    static init() {
      const revealOnScrollSections = document.querySelectorAll('[data-reveal-on-scroll]');
      revealOnScrollSections.forEach((section) => {
        const options = JSON.parse(section.getAttribute('data-reveal-on-scroll'));
        new RevealOnScroll(section, options);
      });
    }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    RevealOnScroll.init();
  });


  class wordPrettifier {
    constructor(container, options = {}) {
      this.wordContainer = container;
      this.containerString = this.wordContainer.innerHTML;
      this.options = Object.assign({
        word: null,
        prettifyEffect: 'string'
      }, options);
  
        if(this.wordExists()) this.prettifyWord()
    }
  
    wordExists(){
      return this.containerString.toLowerCase().includes(this.options.word.toLowerCase())
    }

    prettifyWord(){
      let reg = new RegExp('('+ this.options.word +')', 'gi');
      if(this.options.prettifyEffect.includes('letters')){
        const letters = this.options.word.split('');
        const wrapppedLetters = letters.map((letter, index) => `<b style="animation-delay: .${index * 2}s">${ letter}</b>`);
        this.wordContainer.innerHTML = this.containerString.replace(reg, `<span class="prettify--${this.options.prettifyEffect}">${wrapppedLetters.join('')}</span>`);
      }else{
        this.wordContainer.innerHTML = this.containerString.replace(reg, `<span class="prettify--${this.options.prettifyEffect}">$1</span>`);
      }
    }

    static init() {
      const wordContainers = document.querySelectorAll('[word-prettify]');
      wordContainers.forEach((container) => {
        const options = JSON.parse(container.getAttribute('word-prettify'));
        new wordPrettifier(container, options);
      });
    }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    wordPrettifier.init();
  });


  class AnchorButton {
    constructor(element) {
      this.element = element;

      this.targetElement = document.querySelector(this.element.dataset.target);
      this.headerTop = getComputedStyle(document.documentElement).getPropertyValue('--header-top');
  
      this.element.addEventListener('click', this.handleClick.bind(this));
      window.addEventListener('resize', this.handleResize.bind(this));
    }
  
      handleClick(event) {
        event.preventDefault();

          this.targetElement.scrollIntoView({ behavior: 'smooth' });

      }
  
    handleResize() {
      this.headerTop = getComputedStyle(document.documentElement).getPropertyValue('--header-top');
    }
  
    static forEach(elements, callback) {
      Array.from(elements).forEach(element => {
        const anchorButton = new AnchorButton(element);
        callback(anchorButton);
      });
    }
  
    static init(selector) {
      const anchorButtons = document.querySelectorAll(selector);
      AnchorButton.forEach(anchorButtons, button => {
      });
    }
  }
    document.addEventListener('DOMContentLoaded', () => {
      AnchorButton.init('.anchor-button');
  });


class ColorOptionPreviewer extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const swatches = this.querySelectorAll(".js-swatch-button");
    swatches.forEach((swatch) => {
      swatch.addEventListener("click", (event) => this.handleSwatchClick(event, swatch));
    });
  }

  handleSwatchClick(event, swatch) {
    const primarySrc = swatch.getAttribute("data-primary-src");
    const primarySrcSet = swatch.getAttribute("data-primary-srcset");
    const secondarySrc = swatch.getAttribute("data-secondary-src");
    const secondarySrcSet = swatch.getAttribute("data-secondary-srcset");

    const productItem = swatch.closest("product-item");
    if (!productItem) return;

    const primaryImage = productItem.querySelector(".product-item__primary-image");
    const secondaryImage = productItem.querySelector(".product-item__secondary-image");

    const allSwatchPills = productItem.querySelectorAll('.color-swatch__item');
    allSwatchPills.forEach((pill) => pill.classList.remove('checked'));

    const swatchPill = swatch.querySelector('.color-swatch__item');
    if (swatchPill) {
      swatchPill.classList.add('checked');
    }

    if (primaryImage) {
      this.animateImageChange(primaryImage, primarySrc, this.getImageSrcSet(primarySrcSet));
    }

  }

animateImageChange(imageElement, newSrc, newSrcSet) {
  imageElement.style.transition = "opacity .200s ease-in-out, visibility .200s ease-in-out";
  imageElement.style.opacity = "0"; // Fade out
  
  const onTransitionEnd = () => {
    imageElement.style.removeProperty("opacity");
    imageElement.style.removeProperty("visibility");
    
    imageElement.removeEventListener('transitionend', onTransitionEnd);
  };


  imageElement.addEventListener('transitionend', onTransitionEnd);

  setTimeout(() => {
    imageElement.src = newSrc;
    imageElement.srcset = newSrcSet;
    
    void imageElement.offsetHeight;
    
    imageElement.style.opacity = "1";
    imageElement.style.visibility = "visible";
  }, 200);
}



  getImageSrcSet(src) {
    return `
      ${src}&width=200 200w,
      ${src}&width=300 300w, 
      ${src}&width=400 400w,
      ${src}&width=500 500w,
      ${src}&width=600 600w,
      ${src}&width=700 700w,
      ${src}&width=800 800w,
      ${src}&width=900 900w,
      ${src}&width=1000 1000w,
      ${src}&width=1100 1100w,
      ${src}&width=1200 1200w
    `;
  }
}

customElements.define("color-option-previewer", ColorOptionPreviewer);
